





























































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, Campus } from "../../modules/teacher/CampusList"
import { downloadMasterExcel } from "../../modules/teacher/MasterExcelDownload"

export interface Data {
  tabNo: number
  condition: SearchCondition
  campuses: Campus[]
  fields: any[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  isDownloading: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 2,
      condition: new SearchCondition(),
      campuses: new Array<Campus>(),
      fields: [
        {key: "campus_code", label: "キャンパスCD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "キャンパス名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "80px"}},
      ],
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      isAllDeleteChecked: false,
      isDownloading: false,
      errors: [],
    });

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };
    
    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {
      if(state.isDownloading){
        return;
      }

      state.isDownloading = true;
      try {
        await downloadMasterExcel(context, {
          apiPath: "campus_list",
          condition: state.condition,
          fileName: "キャンパスマスタ.xlsx",
          confirmMessage: "検索条件に一致するキャンパスマスタをダウンロードします。よろしいですか？",
          columns: ["campus_code", "name"],
          deleteColumnCount: 3,
        });
      }
      finally {
        state.isDownloading = false;
      }
    }

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.campuses.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.campuses.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/campus_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = []
      await http.get(`/api/teacher/campus_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.campuses = response.data.campuses.map((x: any) => new Campus(x)); 
        state.totalCount = state.campuses.length == 0 ? 0 : state.campuses[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      allSelectChanged,
      deleteMst,
      searchButtonClick,
      changePage,
      download,
    };
  }
});
